import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import FinanceShell from "@/components/finance/FinanceShell";
import Pagination from "@/components/Pagination";
import { PARTY_TYPE_LABELS, PARTY_TYPE_COLORS, formatTRY } from "@/components/finance/financeLabels";
import { Search, UserPlus } from "lucide-react";

const PAGE_SIZE = 50;

export default function PartiesPage() {
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [q, setQ] = useState("");
    const [type, setType] = useState("");
    const [loading, setLoading] = useState(true);

    const load = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams({ limit: PAGE_SIZE, skip: (page - 1) * PAGE_SIZE });
            if (q) params.set("q", q);
            if (type) params.set("type", type);
            const r = await api.get(`/admin/finance/parties?${params.toString()}`);
            setItems(r.data.items || []);
            setTotal(r.data.total || 0);
        } finally { setLoading(false); }
    };
    useEffect(() => { const t = setTimeout(load, 350); return () => clearTimeout(t); /* eslint-disable-next-line */ }, [q, type, page]);
    useEffect(() => { setPage(1); }, [q, type]);

    return (
        <FinanceShell>
            <div className="flex flex-wrap items-center gap-2 mb-4">
                <div className="relative flex-1 min-w-[200px]">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                    <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari ara (isim, kod, email, vergi no)..." className="w-full pl-9 pr-3 py-2 rounded-lg bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-sm" data-testid="party-search" />
                </div>
                <select value={type} onChange={(e) => setType(e.target.value)} className="px-3 py-2 rounded-lg bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-sm" data-testid="party-type-filter">
                    <option value="">Tüm Tipler</option>
                    {Object.entries(PARTY_TYPE_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
                </select>
            </div>

            <div className="rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 overflow-hidden">
                {loading ? <div className="py-10 text-center text-slate-500">Yükleniyor...</div> : items.length === 0 ? (
                    <div className="py-12 text-center text-slate-500">Cari bulunamadı.</div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm" data-testid="parties-table">
                            <thead className="bg-slate-50 dark:bg-slate-800/60 text-[10px] uppercase tracking-widest font-bold text-slate-500">
                                <tr>
                                    <th className="px-3 py-2 text-left">Kod</th>
                                    <th className="px-3 py-2 text-left">Ad/Ünvan</th>
                                    <th className="px-3 py-2 text-left">Tip</th>
                                    <th className="px-3 py-2 text-left">İletişim</th>
                                    <th className="px-3 py-2 text-left">VKN/TCKN</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((p) => (
                                    <tr key={p.id} className="border-t border-slate-100 dark:border-slate-800/50 hover:bg-slate-50 dark:hover:bg-slate-800/30" data-testid={`party-row-${p.code}`}>
                                        <td className="px-3 py-2 font-mono text-xs">
                                            <Link to={`/admin/finance/parties/${p.id}`} className="text-sky-600 hover:underline font-bold">{p.code}</Link>
                                        </td>
                                        <td className="px-3 py-2 font-semibold">
                                            <Link to={`/admin/finance/parties/${p.id}`} className="hover:underline">{p.name}</Link>
                                        </td>
                                        <td className="px-3 py-2">
                                            <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded-full ${PARTY_TYPE_COLORS[p.type] || ""}`}>{PARTY_TYPE_LABELS[p.type] || p.type}</span>
                                        </td>
                                        <td className="px-3 py-2 text-xs text-slate-500">
                                            {p.email || ""} {p.phone ? ` · ${p.phone}` : ""}
                                        </td>
                                        <td className="px-3 py-2 text-xs text-slate-500">{p.tax_id || "—"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
                <Pagination total={total} page={page} pageSize={PAGE_SIZE} onChange={setPage} label="cari" />
            </div>
        </FinanceShell>
    );
}
